import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import {
	FormControl,
	InputLabel,
	MenuItem,
	RadioGroup,
	FormControlLabel,
	FormLabel
} from '@material-ui/core';

import './pages.css';

const IntroductionPage = ({ handleChange, values, errors }) => {
	const ageRange = () => {
		const arr = [];
		for (let step = 13; step < 70; step++) {
			arr.push(
				<MenuItem key={step} value={step}>
					{step}
				</MenuItem>
			);
		}

		return arr;
	};

	return (
		<>
			<Select
				labelId="demo-simple-select-label"
				id="demo-simple-select"
				value={values.age}
				onChange={handleChange('age')}
				error={!!errors['age']}
			>
				{ageRange()}
			</Select>
		</>
	);
};

export default IntroductionPage;
